import { atom } from 'recoil';

const campaignId = atom<string>({
  key: 'campaignId',
  default: '',
});

export default campaignId;
